import { useModal } from 'hooks/useModal';
import React, { PropsWithChildren } from 'react';
import { WhatIsTargetAchievementSupportModal } from '../modal/WhatIsTargetAchievementSupportModal';
import { TargetCountIsMaxModal } from '../modal/TargetCountIsMaxModal';

const maxTargetCount = 5;

type Props = PropsWithChildren<{
  addTarget: () => void;
  targetCount: number;
}>;

export const TargetList = ({
  addTarget,
  children,
  targetCount,
}: Props): React.ReactElement => {
  const [
    isShowTargetAchievementModal,
    {
      hideModal: hideTargetAchievementModal,
      showModal: showTargetAchievementModal,
    },
  ] = useModal();
  const [
    isShowTargetCountIsMaxModal,
    {
      hideModal: hideTargetCountIsMaxModal,
      showModal: showTargetCountIsMaxModal,
    },
  ] = useModal();

  const goAddTarget = () => {
    if (targetCount < maxTargetCount) {
      addTarget();
    } else {
      showTargetCountIsMaxModal();
    }
  };

  return (
    <>
      <div className={`px-4`}>
        <div
          className={`flex flex-row items-center text-blue-700 mt-3 cursor-pointer`}
          onClick={showTargetAchievementModal}>
          <div className={`ml-auto mr-1 text-sm`}>資産目標サポートとは</div>
          <div className={`icon-info`} />
        </div>
        <div className={`font-bold text-base mt-1`}>登録した目標</div>
        <div className={`flex flex-col gap-2 mt-1`}>{children}</div>
        <div
          className={`mt-5 flex flex-row items-center text-blue-700 justify-center border border-blue-700 rounded-lg shadow py-2 px-4 bg-gray-50 cursor-pointer`}
          onClick={goAddTarget}>
          <div className={`icon-plus text-base mr-2`}></div>
          <div className={`text-base font-bold`}>新しい目標を追加する</div>
        </div>
      </div>
      <WhatIsTargetAchievementSupportModal
        {...{
          isShow: isShowTargetAchievementModal,
          hide: hideTargetAchievementModal,
        }}
      />
      <TargetCountIsMaxModal
        {...{
          isShow: isShowTargetCountIsMaxModal,
          hide: hideTargetCountIsMaxModal,
        }}
      />
    </>
  );
};
